import { loadable } from '../../../utils';

export const ListItem = loadable(() => import('./ListItem'), {});
